var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
export function ExportToExcel(data, filename, sheetname) {
    var _a;
    var fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    var fileExtension = '.xlsx';
    var ws = XLSX.utils.json_to_sheet(data);
    var wb = { Sheets: (_a = {}, _a[sheetname] = ws, _a), SheetNames: [sheetname] };
    var excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    var data2 = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data2, filename + fileExtension);
}
export function ExportToExcelConsolidated(data, filename) {
    var e_1, _a;
    var fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    var fileExtension = '.xlsx';
    // Group data by formatted saleDate
    var groupedData = {};
    data.forEach(function (row) {
        var raw = row.SaleDate;
        if (!groupedData[row.SaleDate]) {
            groupedData[row.SaleDate] = [];
        }
        groupedData[row.SaleDate].push(row);
    });
    var wb = { Sheets: {}, SheetNames: [] };
    try {
        for (var _b = __values(Object.entries(groupedData)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), sheetName = _d[0], rows = _d[1];
            var safeSheetName = sheetName.substring(0, 31);
            var ws = XLSX.utils.json_to_sheet(rows);
            wb.SheetNames.push(safeSheetName);
            wb.Sheets[safeSheetName] = ws;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    var blob = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(blob, filename + fileExtension);
}
